module.exports = __webpack_public_path__ + "static/logo34-24132906543f3e12f661c2edf59818a6.png";